import React from 'react';

export interface OptionalAnchorProps {
	children: React.ReactNode;
	url?: string;
	onClick?: () => void;
}

export function OptionalAnchor({ url, children, onClick }: OptionalAnchorProps) {
	return url ? (
		<a href={url} target="_self" className="roc-product-list__link" onClick={onClick}>
			{children}
		</a>
	) : (
		<>{children}</>
	);
}
